/* eslint-disable */
import FontFaceObserver from 'fontfaceobserver'

// Immediately invoke Font Face Observer
export default (() => {
  let html = document.documentElement
  let heading = new FontFaceObserver('Manrope')
  let body = new FontFaceObserver('Manrope')

  Promise.all([heading.load(), body.load()]).then(
    function() {
      html.classList.add('heading-fonts-loaded')
      html.classList.add('body-fonts-loaded')
    },
    function() {
      html.classList.remove('heading-fonts-loaded')
      html.classList.remove('body-fonts-loaded')
    }
  )
})()



// WEBPACK FOOTER //
// ./scripts/fontface.js